import { Box, Flex, useBreakpointValue } from '@gazin/ecommerce-ui'
import { LoadDepartaments } from 'src/components/loadDepartments'
import { TitleCategory } from 'src/components/loadDepartments/title-category'
import Breadcrumbs from 'src/components/breadcrumbs'

type LoadingSearchCategorySkeletonProps = {
  isCategoryPage?: boolean
}
export const LoadingSearchCategorySkeleton = ({
  isCategoryPage,
}: LoadingSearchCategorySkeletonProps) => {
  const isMobileDevice = useBreakpointValue(
    { base: true, md: true, lg: false },
    { fallback: 'lg' }
  )

  return (
    <>
      <Breadcrumbs loading social />
      <Box
        alignItems="center"
        display={{ base: 'initial', lg: 'flex' }}
        flex="1"
        justifyContent="center"
      >
        <Box
          backgroundColor={{ base: '#f4f4f7', lg: '#ffffff' }}
          display={{ base: 'initial', lg: 'flex' }}
          flex="1"
          flexDirection="column"
          maxWidth="81.875rem"
          paddingX={{ base: '0px', lg: '0.9375rem' }}
          background="red"
        >
          {isCategoryPage && (
            <Box
              width="100%"
              maxWidth="81.875rem"
              marginX="auto"
              marginTop="1rem"
            >
              <TitleCategory isMobile={!!isMobileDevice} />
            </Box>
          )}
          <Flex
            width="100%"
            paddingX={{ base: '0.75rem', lg: 0 }}
            {...(!isCategoryPage && {
              marginTop: { base: '1.5rem', lg: '2rem' },
            })}
          >
            <LoadDepartaments isMobile={!!isMobileDevice} />
          </Flex>
        </Box>
      </Box>
    </>
  )
}
